import { useEffect } from 'react';
import { gsap } from 'gsap';

export default function Footer({ loaded }) {
  useEffect(() => {
    if (!loaded) return;
    gsap.to('.footer-ticker', { x: '-50%', duration: 18, repeat: -1, ease: 'none' });
  }, [loaded]);

  return (
    <footer style={{ borderTop: '1px solid var(--border)', background: 'var(--black)', overflow: 'hidden' }}>
      <div style={{ overflow: 'hidden', padding: '1.5rem 0', borderBottom: '1px solid var(--border)' }}>
        <div className="footer-ticker" style={{ display: 'flex', gap: '4rem', width: '200%', whiteSpace: 'nowrap' }}>
          {Array(16).fill(0).map((_, i) => (
            <span key={i} style={{ fontFamily: 'Syne', fontSize: 'clamp(1.5rem,3vw,2.5rem)', fontWeight: 800, letterSpacing: '-0.03em', color: i % 2 === 0 ? 'var(--muted)' : 'var(--acid)' }}>
              NAVEEN DEV ◆
            </span>
          ))}
        </div>
      </div>
      <div style={{ padding: '2rem 5vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <span style={{ fontFamily: 'Space Mono', fontSize: '0.65rem', color: 'var(--muted)' }}>© 2026 NAVEEN — All Rights Reserved.</span>
        <span style={{ fontFamily: 'Space Mono', fontSize: '0.65rem', color: 'var(--muted)' }}>Design · Development · Innovation</span>
      </div>
    </footer>
  );
}
